import {HeaderTitle} from "../../../common/HeaderTitle.jsx";
import ButtonWithIcon from "../../../common/ButtonWithIcon.jsx";
import {useParams} from "react-router-dom";
import {LinkContainer} from "react-router-bootstrap";
import {useState} from "react";
import {ModalDeletePozycjeSlownika} from "../lib/modals.jsx";
import {SimpleTable} from "../../../common/simpleTable/SimpleTable.jsx";
import {Icons} from "../../../common/Icons.jsx";
import {usePozycjeSlownika} from "../../../../api/domain/slowniki/queries/usePozycjeSlownika.jsx";
import {useSelector} from "react-redux";
import options from "../../../../components/utils/options.js";

const ViewListaPozycjiSlownika = () => {
    const {id: slownik} = useParams()

    const pozycjeSlownika = usePozycjeSlownika(slownik)
    const bluePrint = useSelector(state => state.slownikFormSelected)

    const titleName = `Wszystkie pozycje słownika '${slownik}'`;
    const [openDeleteModal, setOpenDeleteModal] = useState(false)
    const [currPozycja, setCurrPozycja] = useState({
        id: null,
        nazwa: null
    })

    const modals = () => <>
        <ModalDeletePozycjeSlownika
            currPozycja={currPozycja}
            show={openDeleteModal}
            slownik={slownik}
            handleClose={() => setOpenDeleteModal(false)} id={slownik}/>
    </>

    const handleDelete = (id, nazwa) => {
        setCurrPozycja({id, nazwa})
        setOpenDeleteModal(true)
    }

    const td = (row) => {
        return <td>
            <div className={'d-flex gap-2'}>
                <LinkContainer to={`/oper/slownik/edycja/${slownik}/${row.id}`}>
                    <ButtonWithIcon
                        variant={'primary'}
                        size={'sm'} icon={<Icons.edit/>}
                        title='Zarządzaj pozycją słownika'/>
                </LinkContainer>

                <ButtonWithIcon
                    onClick={() => handleDelete(row.id, row.nazwa)}
                    variant={'danger'}
                    size={'sm'} icon={<Icons.delete/>}
                    title='Usuń pozycję słownika'/>
            </div>
        </td>
    }


    const prepareColumns = (data) => {
        return Object.entries(data || {}).map(([key, value]) => ({
            header: value.label,
            columns: Object.entries(value.cols || {}).map(([colKey, colValue]) => {

                return {
                    accessorKey: colKey,
                    meta: colValue?.meta,
                    options: options?.[colValue?.optionsName] || colValue?.options,
                    header: colValue.label,
                    cell:
                        (info) => {
                            return info.getValue();
                        },
                }
            }),
        }))
            ;
    };


    return (
        <div>
            {modals(pozycjeSlownika.refetch)}
            <>
                <HeaderTitle
                    breadcrumbLinks={[
                        {label: `Wszystkie słowniki`, to: '/oper/slowniki/lista'},
                        {label: `Wszystkie pozycje słownika '${slownik}'`},
                    ]}
                    home
                    destination={'/oper/slowniki/lista'}
                    size={'fs-3'}
                    nav
                    title={titleName}/>
                <div className={'d-flex justify-content-end'}>

                    <LinkContainer to={`/oper/slownik/dodaj/${slownik}/nowy`}>
                        <ButtonWithIcon
                            text={'Dodaj pozycję słownika'}
                            variant={'primary'}
                            icon={<Icons.add/>}
                            title='Dodaj pozycję słownika'/>
                    </LinkContainer>
                </div>

                <SimpleTable
                    // columns={listaPozycjiSlownikaColumns}
                    columns={prepareColumns(bluePrint)[1]?.columns}
                    addTh={() => <th>Operacje</th>}
                    addTd={td}
                    data={pozycjeSlownika?.data}
                />
            </>
        </div>
    );
}

export default ViewListaPozycjiSlownika;